document.addEventListener('DOMContentLoaded', function() {
  Localization.init();
});

const Localization = {
  popupDismissKey: 'regionChangePopupDismissed',

  isModalExcludedPath: function(pathname) {
    const segments = (pathname || '').toLowerCase().split('/').filter(Boolean);
    return segments.includes('blogs') || segments.includes('pages');
  },

  hasActiveDismissal: function() {
    try {
      return sessionStorage.getItem(this.popupDismissKey) === 'true';
    } catch (e) {
      return false;
    }
  },

  setDismissal: function() {
    try {
      sessionStorage.setItem(this.popupDismissKey, 'true');
    } catch (e) {
      // Ignore errors
    }
  },

  checkStoreRouting: function() {
    const { shopUrl, marketHandle } = window.SelkirkStore || {};
    if (!shopUrl || !marketHandle) return;

    if (this.isModalExcludedPath(window.location.pathname)) {
      return;
    }

    const isAsiaStore = shopUrl.includes('selkirk-asia') || shopUrl.includes('asia.selkirk.com');
    const isAsiaMarket = marketHandle.includes('asia-3pl-countries');
    const isROWMarket = marketHandle.includes('rest-of-world');

    // On Asia store but Shopify resolved them to ROW → bounce to main store
    if (isAsiaStore && isROWMarket) {
      if (this.hasActiveDismissal()) return;
      Localization.showStorePrompt();
      return;
    }

    // On main store but IP suggests Asia market → prompt to switch, once per session
    if (!isAsiaStore && isAsiaMarket) {
      if (this.hasActiveDismissal()) return;
      Localization.showStorePrompt();
    }
  },

  // DISABLED (kept for reference): builds the URL of the current page on the
  // other store, for the prompt's "Go to ..." button. Currently the button just
  // goes to the other store's homepage.
  //
  // WHY it was written: selkirk.com and asia.selkirk.com are separate Shopify
  // stores, and we don't emit cross-store hreflang (Shopify's built-in tags only
  // cover pages within one store). So a search engine can send a shopper to the
  // wrong store's page, e.g. someone in Singapore searching for a paddle lands
  // on the selkirk.com product page. Ideally the prompt then sends them to that
  // same product on their own store instead of the homepage.
  //
  // WHY it's off: product handles are not always the same on both stores, so a
  // same-path redirect can land on a 404. Variant ids (?variant=) and selling
  // plans are also per-store. To re-enable, we'd need a reliable handle mapping
  // (e.g. match by SKU) and then uncomment this and the call in showStorePrompt.
  //
  // getOtherStoreUrl: function(otherStoreHref) {
  //   try {
  //     const origin = new URL(otherStoreHref).origin;
  //     // Strip the locale prefix (e.g. /vi); the other store may not publish that language
  //     // Shopify.routes.root is '/' for the default language, '/vi/' for Vietnamese
  //     const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  //     const prefix = root.replace(/\/$/, '');
  //     let path = window.location.pathname;
  //     if (prefix && (path === prefix || path.indexOf(prefix + '/') === 0)) {
  //       path = path.slice(prefix.length) || '/';
  //     }
  //     // Cart permalinks (/cart/{variant}:{quantity}) carry variant IDs that only
  //     // exist on this store, so send those shoppers to the other store's homepage
  //     if (/^\/cart\/\d+:\d+/.test(path)) {
  //       return otherStoreHref;
  //     }
  //     // ?variant= (and selling_plan) ids are per-store too, so the other store
  //     // would ignore them or select the wrong option. Drop them and let the
  //     // product page open on its default variant; keep everything else (UTMs etc.)
  //     const params = new URLSearchParams(window.location.search);
  //     params.delete('variant');
  //     params.delete('selling_plan');
  //     const search = params.toString();
  //     return origin + path + (search ? '?' + search : '');
  //   } catch (e) {
  //     return otherStoreHref;
  //   }
  // },

  showStorePrompt: function() {
    const { shopUrl, countryName } = window.SelkirkStore || {};
    const backdrop = document.getElementById('region-change-modal-backdrop');
    const modal = document.getElementById('region-change-modal');
    const title = document.getElementById('region-change-modal-title');
    const body = document.getElementById('region-change-modal-body');
    const stayBtn = document.getElementById('region-change-modal-stay');
    const continueBtn = document.getElementById('region-change-modal-continue');

    if (!backdrop || !modal || !stayBtn || !continueBtn) {
      console.warn('Region change modal elements not found in DOM.');
      return;
    }

    const isAsiaStore = shopUrl && (shopUrl.includes('selkirk-asia') || shopUrl.includes('asia.selkirk.com'));
    const country = countryName || 'your region';

    if (isAsiaStore) {
      title.textContent = 'WELCOME TO SELKIRK ASIA';
      body.textContent = `It looks like you're browsing from ${country}. Selkirk Asia only ships within Asia-Pacific, so you won't be able to complete a purchase here. Please visit selkirk.com to place your order.`;
      stayBtn.textContent = 'Stay anyway';
      continueBtn.textContent = 'Go to selkirk.com';
    } else {
      title.textContent = 'WELCOME TO SELKIRK';
      body.innerHTML = `It looks like you're browsing from ${country}. Switch to <strong>Selkirk Asia</strong> for faster delivery and lower shipping costs`;
      stayBtn.textContent = 'Stay on selkirk.com';
      continueBtn.textContent = 'Go to Selkirk Asia';
    }

    // DISABLED: the "Go to ..." button currently uses the homepage href from the
    // markup, so shoppers always land on the other store's homepage.
    // Same-page redirect is parked because product handles and variant ids can
    // differ between the two stores (a mismatched handle lands on a 404); see
    // the commented-out getOtherStoreUrl above before re-enabling.
    // Set at runtime so the markup keeps the homepage href and crawlers don't
    // see a cross-domain link on every page.
    // continueBtn.href = this.getOtherStoreUrl(continueBtn.getAttribute('href'));

    const close = () => {
      backdrop.classList.remove('is-open');
      modal.classList.remove('is-open');
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.onclick = null;
      stayBtn.onclick = null;
      continueBtn.onclick = null;
    };

    backdrop.classList.add('is-open');
    modal.classList.add('is-open');
    backdrop.setAttribute('aria-hidden', 'false');

    backdrop.onclick = () => {
      close();
      this.setDismissal();
    };

    stayBtn.onclick = () => {
      close();
      this.setDismissal();
    };

    continueBtn.onclick = () => {
      this.setDismissal();
    };
  },

  init: async function() {
    // 0. Handle cross-store routing before anything else
    this.checkStoreRouting();
  }
};